import { parsePhoneNumberFromString } from 'libphonenumber-js/min';
export { getCountries, getCountryCallingCode } from 'libphonenumber-js/core';

function isPossiblePhoneNumber(value) {
  if (typeof value !== 'string') {
    return false;
  }
  var phoneNumber = parsePhoneNumberFromString(value);
  if (!phoneNumber) {
    return false;
  }
  return phoneNumber.isPossible();
}
var makeFormatPhoneNumber = function makeFormatPhoneNumber(format) {
  return function formatPhoneNumber(value) {
    var phoneNumber = parsePhoneNumberFromString(value);
    if (!phoneNumber) {
      return '';
    }
    return phoneNumber.format(format);
  };
};
var formatPhoneNumber = makeFormatPhoneNumber('NATIONAL');
var formatIntlPhoneNumber = makeFormatPhoneNumber('INTERNATIONAL');
var parsePhoneNumber = parsePhoneNumberFromString;

export { formatIntlPhoneNumber, formatPhoneNumber, isPossiblePhoneNumber, parsePhoneNumber };
